var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 28",
    style: {
      enableBackground: "new 0 0 15 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#042b62;}\n\t.st1{fill:none;stroke:#C9EDD7;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3,16.6C1.2,16.6,1.3,16.6,1.3,16.6L1.3,16.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.5,13.6L12,5.3c-0.1-0.6-0.6-1-1.2-1H9.5C8.9,5.4,7.7,6.1,6.4,6.1S3.9,5.4,3.3,4.3H2c-0.6,0-1.2,0.5-1.2,1.1 l-0.7,9.8c0,0.7,0.5,1.3,1.2,1.3c0.6,0,1.2-0.5,1.3-1.1L3,8.8l0,17.2c0,0.8,0.6,1.5,1.4,1.5c0.8,0,1.5-0.6,1.5-1.5v-9.2 c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v9.1c0,0.8,0.6,1.5,1.4,1.5c0.8,0,1.5-0.6,1.5-1.5l0-18.2l1.3,6.3 c-0.4,0.4-0.7,1-0.7,1.6v10.9c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7V16.3c0.2,0.2,0.5,0.3,0.7,0.3c0.1,0,0.1,0,0.2,0 c0.3,0,0.5-0.2,0.6-0.3v0.4c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7v-1C14.9,14.8,14.3,14,13.5,13.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12,16.8c-0.1-1.1,0.2-1.7,0.7-1.7s0.8,0.5,0.7,1.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,0C7.9,0,9,1.2,9,2.6S7.9,5.3,6.4,5.3S3.8,4.1,3.8,2.6S4.9,0,6.4,0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFather);
export default __webpack_public_path__ + "static/media/father.0bdda61b60723d4a5ce7e809b3b7092f.svg";
export { ForwardRef as ReactComponent };